import { Link } from "react-router-dom";
import { Flame, MapPin, Phone, Mail } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-stone-800 border-t border-white/5 pt-16 pb-8 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-saffron to-orange-600 flex items-center justify-center">
                <Flame size={16} className="text-white" />
              </div>
              <span className="font-heading font-bold text-white text-lg">{t.footer.brand}</span>
            </div>
            <p className="text-white/50 text-sm font-body leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4">{t.footer.quick}</h4>
            <ul className="space-y-2">
              {[[t.nav.home, "/"], [t.nav.explore, "/locations"], ["News", "/news"], ["Tools", "/tools"], [t.nav.register, "/register"], [t.nav.about, "/about"]].map(([label, href]) => (
                <li key={href}>
                  <Link to={href} className="text-white/50 text-sm hover:text-saffron transition-colors font-body">{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Important Contacts */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4">{t.footer.emergency}</h4>
            <ul className="space-y-2">
              {[[t.footer.police, "100"], [t.footer.ambulance, "108"], [t.footer.helpline, "1800-121-2028"], [t.footer.tourist, "0734-2510787"]].map(([label, num]) => (
                <li key={label} className="flex items-center gap-2">
                  <Phone size={12} className="text-saffron shrink-0" />
                  <span className="text-white/50 text-sm font-body">{label}: <span className="text-white/70">{num}</span></span>
                </li>
              ))}
            </ul>
          </div>

          {/* Address */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4">{t.footer.location}</h4>
            <div className="flex items-start gap-2 mb-3">
              <MapPin size={14} className="text-saffron mt-0.5 shrink-0" />
              <p className="text-white/50 text-sm font-body">{t.footer.address}</p>
            </div>
            <div className="flex items-center gap-2">
              <Mail size={14} className="text-saffron shrink-0" />
              <a href="mailto:info@ujjainmahakumbh.com" className="text-white/50 text-sm hover:text-saffron transition-colors font-body">info@ujjainmahakumbh.com</a>
            </div>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="border-t border-white/5 pt-6 pb-4 mb-4">
          <div className="bg-amber-900/20 border border-amber-700/30 rounded-xl p-4">
            <h4 className="font-heading text-amber-500 font-semibold text-sm mb-2">{t.footer.disclaimerTitle}</h4>
            <p className="text-white/40 text-xs font-body leading-relaxed">
              {t.footer.disclaimerText}
            </p>
          </div>
        </div>

        {/* Divider + Copyright */}
        <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/30 text-xs font-body text-center">
            {t.footer.copyright}
          </p>
          <p className="text-white/20 text-xs font-body">
            <span className="text-saffron/60">Jai Mahakal</span> • <span className="text-gold/60">Om Namah Shivaya</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
